import { userService } from '../services';
import { router } from '../router';

const user = JSON.parse(localStorage.getItem('user'));
const state = user
  ? { status: { loggedIn: true }, user }
  : { status: {}, user: null };

const actions = {
  login({ dispatch, commit }, { username, password }) {
    commit('loginRequest', { username });

    userService.login(username, password)
      .then(
        user => {
          commit('loginSuccess', user);
          router.push('/');
        },
        error => {
          commit('loginFailure', error);
          dispatch('alert/error', error, { root: true });
        }
      );
  },
  logout({ commit }) {
    userService.logout();
    commit('logout');
  }
};

const mutations = {
  loginRequest(state, user) {
    state.status = { loggingIn: true };
    state.user = user;
  },
  loginSuccess(state, user) {
    state.status = { loggedIn: true };
    state.user = user;
  },
  loginFailure(state) {
    state.status = {};
  },
  logout(state) {
    state.status = {};
    state.user = null;
    router.push('/login');
  }
};

const getters = {
  isAdmin: state => state.user && state.user.isAdmin,
  isInternal: state => state.user && state.user.account && state.user.account.id === 9917
};

export const account = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/account.module.js